// extracted by mini-css-extract-plugin
export var divider = "_t0-0";
export var systemMessage = "_t0-1";